module.exports = __webpack_public_path__ + "static/media/IMG_1636.75067a7b.JPG";